import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';
import uuid from 'vue-uuid';

Vue.config.productionTip = false
Vue.use(uuid);

const appsync_exports = {
  "aws_appsync_graphqlEndpoint": process.env.VUE_APP_AWS_APPSYNC_GRAPHQLENDPOINT,
  "aws_appsync_region": process.env.VUE_APP_AWS_APPSYNC_REGION,
  "aws_appsync_authenticationType": process.env.VUE_APP_AWS_APPSYNC_AUTHENTICATIONTYPE,
  "aws_appsync_apiKey": process.env.VUE_APP_AWS_APPSYNC_APIKEY
}
Amplify.configure(Object.assign({}, aws_exports, appsync_exports))

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
